import React from 'react';
import user from '../Auth/user';
import firebase from '../firebase';
import compose from '../compose';
import { translate } from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { withRouter } from 'react-router-dom';

class StandDelete extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      stand: ''
    };

    this.state = {
      ...this.initialState
    };
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.stand) {
      this.setState({stand: nextProps.stand});
    }
  }
  handleDelete = () => {
    const {firebase, user} = this.props;
    if (!this.state.stand.key) return;
    const standRef = firebase.database().ref(`shopkeepers/${user.shopkeeperId}/stands/${this.state.stand.key}`);
    standRef.remove();
    firebase.database().ref(`shopkeepers/${user.shopkeeperId}/standsList/${this.state.stand.key}`).remove();
    this.props.history.replace('/stands');
  }
  handleClose = () => {
    this.setState({ ...this.initialState});
    this.props.handleClose();
  }

  render()  {
    const {t} = this.props;
    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleClose}
      />,
      <RaisedButton
        label={t('stand.delete')}
        primary={true}
        onTouchTap={this.handleDelete}
      />,
    ];

    return (
      <Dialog title={t('stand.delete')}
      open={this.props.open}
      onRequestClose={this.handleClose}
      actions={actions}>
      {t('stand.deleteDialogText') + ' ' + this.state.stand.name + '?'}
      </Dialog>

    );
  }
}

const enhance = compose(translate(), firebase, user, withRouter);

export default enhance(StandDelete);



// WEBPACK FOOTER //
// ./src/Stand/StandDelete.js